/* global axios */
import WhatsAppSipApiClient from './index';

class TransferNotificationsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('transfer_notifications');
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/transfer_notifications
  // Notify target agent about incoming WhatsApp SIP transfer with caller info
  create(data) {
    return axios.post(this.url, data);
  }
}

export default new TransferNotificationsAPI();
